import Swiper, { Pagination } from "swiper";

export default class VoiceSlider {
  constructor(selector = ".voice__slider") {
    const el = document.querySelector(selector);
    if (!el) return;

    const paginationEl = el.querySelector(".swiper-pagination");
    const mql = window.matchMedia("(min-width: 768px)");
    let swiper;

    const init = () => {
      if (swiper) return;
      swiper = new Swiper(el, {
        modules: [Pagination],
        slidesPerView: 1.3,
        spaceBetween: 16,
        centeredSlides: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    };

    const destroy = () => {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = undefined;
    };

    const handleChange = (event) => (event.matches ? destroy() : init());

    handleChange(mql);
    mql.addEventListener("change", handleChange);
  }
}
